<template>
  <div v-if='visible' class="label-plugin-vue" v-html="text"></div>
</template>

<script>
import { get } from 'lodash'
export default {
  name: "LabelField",
  props: {
    layer: {
      type: Object,
      required: true
    },
    artwork: {
      type: Object,
      required: true
    },
    personalized: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    text() {
      return get(this.layer, 'values[0].text', '');
    },
    visible(){
      return get(this.layer, 'visible', true)
    }
  }
}
</script>

<style scoped>
  .label-plugin-vue{
    padding: 7px 0;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Form/LabelField.vue